<template>
  <div class="no-data">
    <img class="no-data-img" src="@/assets/images/no-data.png" alt=""/>
    <div class="no-data-text">{{ text }}</div>
  </div>
</template>
<script>
export default {
  name: 'TableNoData', // 组件名（必填，用于注册）
  props: {
    // imgUrl: {
    //   type: String,
    //   required: false,
    //   default: () => "@/assets/images/no-data.png",
    // },
    text: {
      type: String,
      required: false,
      default: () => "暂无数据",
    },
  },
}
</script>
<style>
.no-data {
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .no-data-img {
    width: 180px;
    height: 140px;
    margin-bottom: 20px;
  }

  .no-data-text {
    font-size: 14px;
    color: #909399;
  }
}
</style>
